import React, { FC } from 'react';

import cn from 'classnames';

import css from './stepLabel.css';

interface StepLabelProps {
    className?: string;
}

const StepLabel: FC<React.PropsWithChildren<StepLabelProps>> = ({
    className,
    children,
}) => <span className={cn(css.root, className)}>{children}</span>;

export default StepLabel;
